import {
	reOrgConstructionMaterialCharacteristicConstants
}from "./constants"
import actions from "../../actions"

const initialState = {
	isSending : false,
	paged     : {},
	changed   : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reOrgConstructionMaterialCharacteristicConstants.CLEAR:
			return {
				...state,
				paged     : {},
				changed   : null,
				isSending : false
			}
		case reOrgConstructionMaterialCharacteristicConstants.UpdateCharacteristics.REQUEST:
		case reOrgConstructionMaterialCharacteristicConstants.GetMaterials.REQUEST:
		case reOrgConstructionMaterialCharacteristicConstants.UpdateFileCharacteristics.REQUEST:
		case reOrgConstructionMaterialCharacteristicConstants.GetFileCharacteristics.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reOrgConstructionMaterialCharacteristicConstants.UpdateCharacteristics.FAILURE:
		case reOrgConstructionMaterialCharacteristicConstants.GetMaterials.FAILURE:
		case reOrgConstructionMaterialCharacteristicConstants.UpdateFileCharacteristics.FAILURE:
		case reOrgConstructionMaterialCharacteristicConstants.GetFileCharacteristics.FAILURE:
			return {
				...state,
				error     : action.payload,
				isSending : false,
				changed   : null
			}
		case reOrgConstructionMaterialCharacteristicConstants.GetFileCharacteristics.SUCCESS:
			return {
				...state,
				isSending: false
			}
		case reOrgConstructionMaterialCharacteristicConstants.GetMaterials.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reOrgConstructionMaterialCharacteristicConstants.UpdateCharacteristics.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reOrgConstructionMaterialCharacteristicConstants.UpdateFileCharacteristics.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.download : null
			}
		default:
			return state
	}
}
